<div class="info-background">
  <slotcom-navigation-button
    type="close"
    topPosition="1"
    rightPosition="3"
    (click)="closeInfo()"></slotcom-navigation-button>
  <span class="info-title">{{ 'home.trophies-modal.info.title' | translate }}</span>

  <div class="info-steps-container">
    <ng-container *ngTemplateOutlet="infoStep; context: { imgStep: 1 }"> </ng-container>

    <div
      theming
      themingGroup="dailychallenge"
      themingAsset="arrow"
      class="arrow-image"></div>

    <ng-container *ngTemplateOutlet="infoStep; context: { imgStep: 2 }"> </ng-container>

    <div
      theming
      themingGroup="dailychallenge"
      themingAsset="arrow"
      class="arrow-image"></div>

    <ng-container *ngTemplateOutlet="infoStep; context: { imgStep: 3 }"> </ng-container>
  </div>
</div>

<ng-template
  #infoStep
  let-imgStep="imgStep">
  <div class="info-step">
    <div
      class="step-image"
      theming
      themingGroup="none"
      [themingAsset]="'info-trophies-modal-step-' + imgStep"></div>
    <span class="step-text">{{ 'home.trophies-modal.info.step-' + imgStep | translate }}</span>
  </div>
</ng-template>
